import { useState, useEffect } from 'react';

// Mobile detection hook with 640px breakpoint
export function useIsMobile() {
  const [isMobile, setIsMobile] = useState(() => {
    // Check if we're in browser environment
    if (typeof window === 'undefined') {
      return false;
    }
    
    // Optimized initial check with caching
    const lastMobile = sessionStorage.getItem('lastMobileState') !== null ? 
      sessionStorage.getItem('lastMobileState') === 'true' : null;
    
    if (lastMobile !== null) {
      // Quick validation - if window size hasn't changed significantly
      if (Math.abs(window.innerWidth - (parseInt(sessionStorage.getItem('lastWindowWidth')) || 0)) < 50) {
        const windowStillMobile = window.innerWidth <= 640;
        if (lastMobile === windowStillMobile) {
          return lastMobile;
        }
      }
      
      // Cache is stale, do fresh check
      const currentMobile = window.innerWidth <= 640;
      sessionStorage.setItem('lastMobileState', currentMobile.toString());
      sessionStorage.setItem('lastWindowWidth', window.innerWidth.toString());
      
      return currentMobile;
    }
    });

  useEffect(() => {
    const check = () => {
      const mobile = window.innerWidth <= 640;
      setIsMobile(mobile);
      
      // Cache the result for performance
      sessionStorage.setItem('lastMobileState', mobile.toString());
      sessionStorage.setItem('lastWindowWidth', window.innerWidth.toString());
    };

    // Add resize listener
    window.addEventListener('resize', check);
    
    // Initial check
    check();

    return () => window.removeEventListener('resize', check);
  }, []);

  return isMobile;
}